import { FCNDPartners, FCND_COURSES, FCND_S12NS } from 'bundles/enterprise-legacy-learner-home/constants/xdpConstants';
import GrowthDegreesExperiments from 'bundles/epic/clients/GrowthDegrees';

const isForCreditNonDegree = (slug: string, partner: string) => {
  return (
    (FCND_COURSES.has(slug) || FCND_S12NS.has(slug)) &&
    FCNDPartners.has(partner) &&
    GrowthDegreesExperiments.get('FCNDUpsellV2')
  );
};

export default isForCreditNonDegree;
